import { gql } from '@apollo/client';
import {
  Avatar,
  AvatarGroup,
  AvatarGroupProps,
  useDisclosure,
} from '@chakra-ui/react';
import { DocumentNode } from 'graphql';
import * as React from 'react';

import { OptionVotes_PollV2Fragment_options } from './graphql-types/OptionVotes_PollV2Fragment';

import { VotesModal } from './components/VotesModal';

export const OptionVotes: React.FC<
  {
    option: OptionVotes_PollV2Fragment_options;
  } & Omit<AvatarGroupProps, 'children'>
> & {
  pollFragment: DocumentNode;
} = ({ option, ...avatarGroupProps }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <AvatarGroup
        cursor="pointer"
        max={2}
        size="sm"
        onClick={onOpen}
        {...avatarGroupProps}
      >
        {option.responses?.map((response) => {
          return (
            <Avatar
              key={response._id}
              src={response.user.proxyProfilePictureUrl || undefined}
              name={response.user.displayName}
            />
          );
        })}
      </AvatarGroup>
      <VotesModal isOpen={isOpen} onClose={onClose} option={option} />
    </>
  );
};

OptionVotes.pollFragment = gql`
  fragment OptionVotes_PollV2Fragment on PollV2 {
    _id
    options {
      _id
      responses {
        _id
        user {
          _id
          displayName
          proxyProfilePictureUrl(
            input: { w: 48, h: 48, fit: "facearea", facepad: 10.0 }
          )
        }
      }
      ...VotesModal_PollOptionFragment
    }
  }
  ${VotesModal.pollOptionFragment}
`;
